import { PerformanceReviewEditPageStep } from "@/pages/talent/performance-reviews/edit/performance-review-edit.ts";
import { ApiPerformanceReviewEdit } from "@/types/performance-review.types.ts";
import { Avatar, DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const performanceReviewSteps = [
  PerformanceReviewEditPageStep.details,
  PerformanceReviewEditPageStep.reviewers,
  PerformanceReviewEditPageStep.forms,
  PerformanceReviewEditPageStep.settings,
  PerformanceReviewEditPageStep.invitation,
  PerformanceReviewEditPageStep.ratings,
  PerformanceReviewEditPageStep.notifications,
];

interface PerformanceReviewTitleSlotProps {
  step: PerformanceReviewEditPageStep;
  review?: ApiPerformanceReviewEdit;
}

export const PerformanceReviewTitleSlot = ({ step, review }: PerformanceReviewTitleSlotProps) => {
  const { t } = useTranslation();
  const stepIndex = performanceReviewSteps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("performance_review:performance_review")}</Text>
      {stepIndex > 0 && review && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          {review.emoji && <Avatar emoji={review.emoji} size={"sm"} />}
          <Text className={"font-semibold"}>{review.title}</Text>
        </Stack>
      )}
      <Text>
        {t("core:step_of", {
          currentStep: stepIndex + 1,
          countSteps: performanceReviewSteps.length,
        })}
      </Text>
    </DotSeparator>
  );
};
